import React, {useState} from 'react';
import {XMarkIcon} from '@heroicons/react/24/outline';
import styles from './WriteRemarksPopUp.module.css';
import Button from "../../../components/common/button/Button";

interface WriteRemarksPopUpProps {
    isOpen: boolean;
    onClose: () => void;
    reportId?: number;
}

//특이사항 작성 팝업
const WriteRemarksPopUp: React.FC<WriteRemarksPopUpProps> = ({
                                                                 isOpen,
                                                                 onClose,
                                                                 reportId
                                                             }) => {
    const [remark, setRemark] = useState<string>('');

    const handleSubmit = async () => {
        //보고서 생성 코드 연결 필요
    };

    if (!isOpen) return null;

    return (
        <div className={styles.overlay}>
            <div className={styles.modal}>
                <div className={styles.header}>
                    <h2 className={styles.title}>특이사항 작성</h2>
                    {/*닫기 버튼*/}
                    <button onClick={onClose} className={styles.closeButton}>
                        <XMarkIcon className={styles.closeIcon}/>
                    </button>
                </div>

                <div className={styles.content}>
                    <div className={styles.formGroup}>
                        {/*특이사항 입력*/}
                        <label>특이사항</label>
                        <textarea
                            value={remark}
                            onChange={(e) => setRemark(e.target.value)}
                            placeholder="특이사항을 적어주세요"
                            className={styles.textarea}
                        />
                    </div>
                </div>

                <div className={styles.footer}>
                    {/*저장 버튼*/}
                    <Button
                        variant="primary"
                        onClick={handleSubmit}
                        disabled={!remark.trim()}
                        className={styles.submitButton}
                    >
                        저장
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default WriteRemarksPopUp;